// ============================================================
// bankSoalLogika.js — Bank Soal Logika & Numerik TNI
// Mencakup: Deret Angka, Aritmatika Cerita, NAT-2, ART-2,
//           Konsep Hitungan/Daradat
// ============================================================

// ------------------------------------------------------------
// 1. DERET ANGKA (Kelompok Soal 06 + NAT-2)
//    Format: tampilkan deret, user isi angka berikutnya
// ------------------------------------------------------------
export const soalDeretAngka = [
  // --- Pola Tambah ---
  { id: 'DRT-001', deret: '2, 4, 6, 8, 10, ...', jawaban: 12, pola: '+2' },
  { id: 'DRT-002', deret: '3, 6, 9, 12, 15, ...', jawaban: 18, pola: '+3' },
  { id: 'DRT-003', deret: '5, 10, 15, 20, 25, ...', jawaban: 30, pola: '+5' },
  { id: 'DRT-004', deret: '1, 4, 7, 10, 13, ...', jawaban: 16, pola: '+3' },
  { id: 'DRT-005', deret: '7, 11, 15, 19, 23, ...', jawaban: 27, pola: '+4' },
  { id: 'DRT-006', deret: '10, 17, 24, 31, 38, ...', jawaban: 45, pola: '+7' },
  { id: 'DRT-007', deret: '4, 9, 14, 19, 24, ...', jawaban: 29, pola: '+5' },
  { id: 'DRT-008', deret: '6, 13, 20, 27, 34, ...', jawaban: 41, pola: '+7' },

  // --- Pola Kurang ---
  { id: 'DRT-009', deret: '50, 45, 40, 35, 30, ...', jawaban: 25, pola: '-5' },
  { id: 'DRT-010', deret: '100, 91, 82, 73, 64, ...', jawaban: 55, pola: '-9' },
  { id: 'DRT-011', deret: '80, 74, 68, 62, 56, ...', jawaban: 50, pola: '-6' },
  { id: 'DRT-012', deret: '200, 184, 168, 152, 136, ...', jawaban: 120, pola: '-16' },

  // --- Pola Kali ---
  { id: 'DRT-013', deret: '2, 4, 8, 16, 32, ...', jawaban: 64, pola: 'x2' },
  { id: 'DRT-014', deret: '3, 9, 27, 81, 243, ...', jawaban: 729, pola: 'x3' },
  { id: 'DRT-015', deret: '1, 2, 4, 8, 16, ...', jawaban: 32, pola: 'x2' },
  { id: 'DRT-016', deret: '5, 10, 20, 40, 80, ...', jawaban: 160, pola: 'x2' },
  { id: 'DRT-017', deret: '2, 6, 18, 54, 162, ...', jawaban: 486, pola: 'x3' },

  // --- Pola Bagi ---
  { id: 'DRT-018', deret: '256, 128, 64, 32, 16, ...', jawaban: 8, pola: '÷2' },
  { id: 'DRT-019', deret: '729, 243, 81, 27, 9, ...', jawaban: 3, pola: '÷3' },
  { id: 'DRT-020', deret: '1000, 500, 250, 125, ...', jawaban: 62.5, pola: '÷2' },

  // --- Pola Campuran (+/-) ---
  { id: 'DRT-021', deret: '1, 3, 2, 4, 3, 5, 4, ...', jawaban: 6, pola: '+2,-1 bergantian' },
  { id: 'DRT-022', deret: '2, 5, 4, 7, 6, 9, 8, ...', jawaban: 11, pola: '+3,-1 bergantian' },
  { id: 'DRT-023', deret: '10, 5, 15, 10, 20, 15, ...', jawaban: 25, pola: '-5,+10 bergantian' },
  { id: 'DRT-024', deret: '1, 2, 4, 5, 7, 8, 10, ...', jawaban: 11, pola: '+1,+2 bergantian' },
  { id: 'DRT-025', deret: '3, 6, 5, 10, 9, 18, 17, ...', jawaban: 34, pola: 'x2,-1 bergantian' },

  // --- Pola Dua Selang ---
  { id: 'DRT-026', deret: '2, 3, 4, 6, 8, 12, 16, ...', jawaban: 24, pola: 'dua deret x2' },
  { id: 'DRT-027', deret: '1, 1, 2, 3, 5, 8, 13, ...', jawaban: 21, pola: 'Fibonacci' },
  { id: 'DRT-028', deret: '0, 1, 1, 2, 3, 5, 8, ...', jawaban: 13, pola: 'Fibonacci' },
  { id: 'DRT-029', deret: '4, 7, 12, 19, 28, ...', jawaban: 39, pola: '+3,+5,+7,+9,...' },
  { id: 'DRT-030', deret: '1, 4, 9, 16, 25, ...', jawaban: 36, pola: 'kuadrat' },

  // --- NAT-2 style (isi jawaban angka) ---
  { id: 'NAT-001', deret: '15, 13, 11, 9, 7, ...', jawaban: 5, pola: '-2' },
  { id: 'NAT-002', deret: '3, 5, 8, 12, 17, ...', jawaban: 23, pola: '+2,+3,+4,+5,...' },
  { id: 'NAT-003', deret: '48, 24, 12, 6, 3, ...', jawaban: 1.5, pola: '÷2' },
  { id: 'NAT-004', deret: '7, 14, 28, 56, 112, ...', jawaban: 224, pola: 'x2' },
  { id: 'NAT-005', deret: '100, 95, 85, 70, 50, ...', jawaban: 25, pola: '-5,-10,-15,-20,...' },
  { id: 'NAT-006', deret: '2, 3, 5, 9, 17, ...', jawaban: 33, pola: 'x2-1' },
  { id: 'NAT-007', deret: '81, 27, 9, 3, 1, ...', jawaban: 1/3, pola: '÷3' },
  { id: 'NAT-008', deret: '1, 8, 27, 64, 125, ...', jawaban: 216, pola: 'n^3' },
  { id: 'NAT-009', deret: '5, 6, 8, 11, 15, 20, ...', jawaban: 26, pola: '+1,+2,+3,+4,...' },
  { id: 'NAT-010', deret: '2, 4, 3, 6, 5, 10, 9, ...', jawaban: 18, pola: 'x2,-1 bergantian' },

  // --- Deret Hitung (Test I) — tambahan dari bank soal Ojik, 20 soal ---
  // Semua sudah dicek: pola & jawaban dihitung ulang & diverifikasi (bukan cuma
  // disalin), dan dipastikan tidak ada deret yang sama persis dengan yang sudah
  // ada di atas.
  { id: 'DRT-031', deret: '6, 9, 12, 15, 18, 21, 24, 27, ...', jawaban: 30, pola: '+3' },
  { id: 'DRT-032', deret: '15, 16, 18, 19, 21, 22, 24, 25, ...', jawaban: 27, pola: '+1,+2 bergantian' },
  { id: 'DRT-033', deret: '19, 18, 22, 21, 25, 24, 28, 27, ...', jawaban: 31, pola: '-1,+4 bergantian' },
  { id: 'DRT-034', deret: '16, 12, 17, 13, 18, 14, 19, 15, ...', jawaban: 20, pola: '-4,+5 bergantian' },
  { id: 'DRT-035', deret: '2, 4, 8, 10, 20, 22, 44, 46, ...', jawaban: 92, pola: '+2,x2 bergantian' },
  { id: 'DRT-036', deret: '15, 13, 16, 12, 17, 11, 18, 10, ...', jawaban: 19, pola: 'dua deret +1/-1 bergantian' },
  { id: 'DRT-037', deret: '25, 22, 11, 33, 30, 15, 45, 42, ...', jawaban: 21, pola: 'kelompok 3: -3 lalu ÷2 (kelompok berikutnya x3)' },
  { id: 'DRT-038', deret: '49, 51, 54, 27, 9, 11, 14, 7, ...', jawaban: 7 / 3, pola: '+2,+3,÷2,÷3 berulang' },
  { id: 'DRT-039', deret: '2, 3, 1, 3, 4, 2, 4, 5, ...', jawaban: 3, pola: 'kelompok 3: a,a+1,a-1 (a naik 1)' },
  { id: 'DRT-040', deret: '19, 17, 20, 16, 21, 15, 22, 14, ...', jawaban: 23, pola: 'dua deret +1/-1 bergantian' },
  { id: 'DRT-041', deret: '94, 92, 46, 44, 22, 20, 10, 8, ...', jawaban: 4, pola: '-2,÷2 bergantian' },
  { id: 'DRT-042', deret: '5, 8, 9, 8, 11, 12, 11, 14, ...', jawaban: 15, pola: '+3,+1,-1 berulang' },
  { id: 'DRT-043', deret: '12, 15, 19, 23, 28, 33, 39, 45, ...', jawaban: 52, pola: 'selisih naik bertahap (+3,+4,+4,+5,+5,...)' },
  { id: 'DRT-044', deret: '7, 5, 10, 7, 21, 17, 68, 63, ...', jawaban: 315, pola: 'pasangan: selisih & pengali naik bertahap' },
  { id: 'DRT-045', deret: '11, 15, 18, 9, 13, 16, 8, 12, ...', jawaban: 15, pola: 'kelompok 3: +4,+3, lalu berkurang bertahap' },
  { id: 'DRT-046', deret: '3, 8, 15, 24, 35, 48, 63, 80, ...', jawaban: 99, pola: 'n x (n+2)' },
  { id: 'DRT-047', deret: '4, 5, 7, 4, 8, 13, 7, 14, ...', jawaban: 22, pola: 'selisih +1,+2,-3 (kelipatan 3 makin besar)' },
  { id: 'DRT-048', deret: '8, 5, 15, 18, 6, 3, 9, 12, ...', jawaban: 4, pola: '-3,x3,+3,÷3 berulang' },
  { id: 'DRT-049', deret: '15, 6, 18, 10, 30, 23, 69, 63, ...', jawaban: 189, pola: 'genap = ganjil dikurangi bertahap; ganjil berikut = genap x3' },
  { id: 'DRT-050', deret: '5, 35, 28, 4, 11, 77, 70, 10, ...', jawaban: 17, pola: 'x7,-7,÷7,+7 berulang' },
];

// ------------------------------------------------------------
// 2. ARITMATIKA CERITA (Kelompok Soal 05 + ART-2)
//    Format: pilihan ganda a/b/c/d/e
// ------------------------------------------------------------
export const soalAritmatika = [
  // --- Kelompok Soal 05 style ---
  {
    id: 'ARI-001',
    soal: 'Seorang prajurit berlari 8 km pada hari pertama, 10 km pada hari kedua, dan 12 km pada hari ketiga. Berapa rata-rata km yang ditempuh per hari?',
    pilihan: { a: '8 km', b: '9 km', c: '10 km', d: '11 km', e: '12 km' },
    jawaban: 'c',
    pembahasan: '(8+10+12) ÷ 3 = 30 ÷ 3 = 10 km'
  },
  {
    id: 'ARI-002',
    soal: 'Sebuah barak menampung 120 prajurit. Jika 1/4 dari prajurit dipindahkan ke pos lain, berapa prajurit yang tersisa?',
    pilihan: { a: '30', b: '60', c: '80', d: '90', e: '100' },
    jawaban: 'd',
    pembahasan: '120 - (120 × 1/4) = 120 - 30 = 90'
  },
  {
    id: 'ARI-003',
    soal: 'Jika seorang perwira memiliki gaji Rp 5.000.000 dan mendapat tunjangan 40% dari gajinya, berapa total penghasilannya?',
    pilihan: { a: 'Rp 6.500.000', b: 'Rp 7.000.000', c: 'Rp 7.500.000', d: 'Rp 8.000.000', e: 'Rp 8.500.000' },
    jawaban: 'b',
    pembahasan: '5.000.000 + (40% × 5.000.000) = 5.000.000 + 2.000.000 = 7.000.000'
  },
  {
    id: 'ARI-004',
    soal: 'Sebuah kendaraan militer menempuh jarak 360 km dalam 6 jam. Berapa kecepatan rata-ratanya?',
    pilihan: { a: '50 km/jam', b: '55 km/jam', c: '60 km/jam', d: '65 km/jam', e: '70 km/jam' },
    jawaban: 'c',
    pembahasan: '360 ÷ 6 = 60 km/jam'
  },
  {
    id: 'ARI-005',
    soal: 'Dari 200 peserta seleksi TNI, 30% dinyatakan lulus. Berapa orang yang lulus?',
    pilihan: { a: '40', b: '50', c: '60', d: '70', e: '80' },
    jawaban: 'c',
    pembahasan: '30% × 200 = 60 orang'
  },
  {
    id: 'ARI-006',
    soal: 'Sebuah gudang amunisi memiliki 500 peluru. Dalam 5 hari latihan, digunakan 200 peluru. Berapa sisa peluru rata-rata yang terpakai per hari?',
    pilihan: { a: '30', b: '35', c: '40', d: '45', e: '50' },
    jawaban: 'c',
    pembahasan: '200 ÷ 5 = 40 peluru/hari'
  },
  {
    id: 'ARI-007',
    soal: 'Jika 3 prajurit dapat menyelesaikan tugas dalam 12 hari, berapa hari yang diperlukan 6 prajurit untuk tugas yang sama?',
    pilihan: { a: '4 hari', b: '5 hari', c: '6 hari', d: '8 hari', e: '9 hari' },
    jawaban: 'c',
    pembahasan: '(3 × 12) ÷ 6 = 36 ÷ 6 = 6 hari'
  },
  {
    id: 'ARI-008',
    soal: 'Sebuah pos jaga dijaga oleh 4 orang secara bergiliran selama 24 jam. Berapa jam jaga masing-masing orang?',
    pilihan: { a: '4 jam', b: '5 jam', c: '6 jam', d: '7 jam', e: '8 jam' },
    jawaban: 'c',
    pembahasan: '24 ÷ 4 = 6 jam'
  },
  {
    id: 'ARI-009',
    soal: 'Harga sebuah seragam militer adalah Rp 450.000. Jika mendapat diskon 20%, berapa harga yang harus dibayar?',
    pilihan: { a: 'Rp 320.000', b: 'Rp 340.000', c: 'Rp 360.000', d: 'Rp 380.000', e: 'Rp 400.000' },
    jawaban: 'c',
    pembahasan: '450.000 - (20% × 450.000) = 450.000 - 90.000 = 360.000'
  },
  {
    id: 'ARI-010',
    soal: 'Seorang prajurit harus menempuh perjalanan 45 km. Jika sudah menempuh 2/3 perjalanan, berapa km lagi yang harus ditempuh?',
    pilihan: { a: '10 km', b: '12 km', c: '15 km', d: '18 km', e: '20 km' },
    jawaban: 'c',
    pembahasan: '45 - (2/3 × 45) = 45 - 30 = 15 km'
  },

  // --- ART-2 style (soal cerita hitungan) ---
  {
    id: 'ART-001',
    soal: 'Kompi A terdiri dari 150 prajurit dan Kompi B terdiri dari 120 prajurit. Jika digabung dan dibagi menjadi 9 regu sama besar, berapa anggota tiap regu?',
    pilihan: { a: '25', b: '28', c: '30', d: '32', e: '35' },
    jawaban: 'c',
    pembahasan: '(150 + 120) ÷ 9 = 270 ÷ 9 = 30'
  },
  {
    id: 'ART-002',
    soal: 'Dalam latihan menembak, Budi menembak 15 kali dengan 9 kali mengenai sasaran. Berapa persen tingkat akurasinya?',
    pilihan: { a: '55%', b: '60%', c: '65%', d: '70%', e: '75%' },
    jawaban: 'b',
    pembahasan: '(9 ÷ 15) × 100% = 60%'
  },
  {
    id: 'ART-003',
    soal: 'Sebuah truk militer mengangkut 2.400 kg muatan. Jika setiap peti berisi 80 kg, berapa peti yang diangkut?',
    pilihan: { a: '25', b: '28', c: '30', d: '32', e: '35' },
    jawaban: 'c',
    pembahasan: '2400 ÷ 80 = 30 peti'
  },
  {
    id: 'ART-004',
    soal: 'Panjang lapangan upacara adalah 120 meter dan lebarnya 80 meter. Berapa luas lapangan tersebut?',
    pilihan: { a: '8.400 m²', b: '9.000 m²', c: '9.600 m²', d: '10.000 m²', e: '10.200 m²' },
    jawaban: 'c',
    pembahasan: '120 × 80 = 9.600 m²'
  },
  {
    id: 'ART-005',
    soal: 'Seorang prajurit menabung Rp 200.000 per bulan. Setelah berapa bulan tabungannya mencapai Rp 2.400.000?',
    pilihan: { a: '10 bulan', b: '11 bulan', c: '12 bulan', d: '13 bulan', e: '14 bulan' },
    jawaban: 'c',
    pembahasan: '2.400.000 ÷ 200.000 = 12 bulan'
  },
  {
    id: 'ART-006',
    soal: 'Kecepatan kapal patroli 45 knot. Jika harus menempuh 270 mil laut, berapa jam waktu yang dibutuhkan?',
    pilihan: { a: '4 jam', b: '5 jam', c: '6 jam', d: '7 jam', e: '8 jam' },
    jawaban: 'c',
    pembahasan: '270 ÷ 45 = 6 jam'
  },
  {
    id: 'ART-007',
    soal: 'Dalam satu peleton terdapat 40 prajurit. Jika 15% sakit, berapa prajurit yang hadir latihan?',
    pilihan: { a: '32', b: '33', c: '34', d: '35', e: '36' },
    jawaban: 'c',
    pembahasan: '40 - (15% × 40) = 40 - 6 = 34'
  },
  {
    id: 'ART-008',
    soal: 'Senapan A dapat menembak 30 peluru per menit, senapan B 45 peluru per menit. Berapa total peluru yang ditembakkan dalam 4 menit?',
    pilihan: { a: '280', b: '290', c: '300', d: '310', e: '320' },
    jawaban: 'c',
    pembahasan: '(30 + 45) × 4 = 75 × 4 = 300 peluru'
  },
  {
    id: 'ART-009',
    soal: 'Perjalanan dari markas ke pos terdepan berjarak 84 km. Dengan kecepatan 42 km/jam, berapa lama perjalanannya?',
    pilihan: { a: '1 jam', b: '1,5 jam', c: '2 jam', d: '2,5 jam', e: '3 jam' },
    jawaban: 'c',
    pembahasan: '84 ÷ 42 = 2 jam'
  },
  {
    id: 'ART-010',
    soal: 'Seorang tamtama mendapat gaji Rp 3.200.000. Jika dipotong 5% untuk iuran, berapa gaji bersih yang diterima?',
    pilihan: { a: 'Rp 2.960.000', b: 'Rp 2.980.000', c: 'Rp 3.000.000', d: 'Rp 3.040.000', e: 'Rp 3.060.000' },
    jawaban: 'd',
    pembahasan: '3.200.000 - (5% × 3.200.000) = 3.200.000 - 160.000 = 3.040.000'
  },

  // --- Konsep Hitungan / Daradat ---
  {
    id: 'KON-001',
    soal: '√144 + 5² = ?',
    pilihan: { a: '35', b: '37', c: '39', d: '41', e: '43' },
    jawaban: 'b',
    pembahasan: '√144 = 12, 5² = 25, 12 + 25 = 37'
  },
  {
    id: 'KON-002',
    soal: '(24 ÷ 4) × (3 + 5) = ?',
    pilihan: { a: '42', b: '46', c: '48', d: '52', e: '56' },
    jawaban: 'c',
    pembahasan: '6 × 8 = 48'
  },
  {
    id: 'KON-003',
    soal: '15% dari 240 adalah?',
    pilihan: { a: '32', b: '34', c: '36', d: '38', e: '40' },
    jawaban: 'c',
    pembahasan: '15/100 × 240 = 36'
  },
  {
    id: 'KON-004',
    soal: '3/4 + 1/3 = ?',
    pilihan: { a: '11/12', b: '12/12', c: '13/12', d: '14/12', e: '15/12' },
    jawaban: 'c',
    pembahasan: '9/12 + 4/12 = 13/12'
  },
  {
    id: 'KON-005',
    soal: '2³ × 3² = ?',
    pilihan: { a: '54', b: '64', c: '72', d: '80', e: '90' },
    jawaban: 'c',
    pembahasan: '8 × 9 = 72'
  },
  {
    id: 'KON-006',
    soal: 'Jika x + 7 = 15, maka 3x = ?',
    pilihan: { a: '18', b: '21', c: '24', d: '27', e: '30' },
    jawaban: 'c',
    pembahasan: 'x = 8, maka 3x = 24'
  },
  {
    id: 'KON-007',
    soal: '(18 + 12) ÷ (9 - 4) = ?',
    pilihan: { a: '4', b: '5', c: '6', d: '7', e: '8' },
    jawaban: 'c',
    pembahasan: '30 ÷ 5 = 6'
  },
  {
    id: 'KON-008',
    soal: 'Berapa nilai 40% dari 750?',
    pilihan: { a: '270', b: '290', c: '300', d: '320', e: '350' },
    jawaban: 'c',
    pembahasan: '40/100 × 750 = 300'
  },
  {
    id: 'KON-009',
    soal: '√225 × √25 = ?',
    pilihan: { a: '65', b: '70', c: '75', d: '80', e: '85' },
    jawaban: 'c',
    pembahasan: '15 × 5 = 75'
  },
  {
    id: 'KON-010',
    soal: 'Hasil dari 4! (4 faktorial) adalah?',
    pilihan: { a: '16', b: '20', c: '24', d: '28', e: '32' },
    jawaban: 'c',
    pembahasan: '4! = 4 × 3 × 2 × 1 = 24'
  },

  // --- Aritmatika Cerita (dari file ARIMATIKA.docx, Ojik) ---
  // File aslinya cuma kasih soal + pilihan, tanpa kunci jawaban — semua
  // dihitung ulang & diverifikasi satu-satu. 11 soal dari sumbernya (nomor
  // 10, 13, 14, 15, 17, 22, 25, 27, 37, 43, 50) SENGAJA TIDAK dimasukkan
  // karena hasil hitungannya tidak cocok dengan pilihan jawaban yang ada di
  // dokumen (kemungkinan ada angka/kata yang salah ketik di soal aslinya)
  // — lihat catatan yang saya kirim di chat untuk detail per nomor.
  {
    id: 'ARI-011',
    soal: 'Sebuah pesawat terbang menempuh jarak 3 km dalam waktu 15 detik. Berapa kecepatan pesawat terbang tersebut?',
    pilihan: { a: '440 km/jam', b: '520 km/jam', c: '600 km/jam', d: '720 km/jam' },
    jawaban: 'd',
    pembahasan: '3 km / 15 detik = 0,2 km/detik. Per jam: 0,2 × 3600 = 720 km/jam'
  },
  {
    id: 'ARI-012',
    soal: 'Jatmiko berjalan dari kota A ke kota B dengan kecepatan 8 km/jam selama 5 jam dan ia kembali ke kota A dengan naik motor selama 3 jam. Berapa kecepatan rata-rata seluruh perjalanan Jatmiko?',
    pilihan: { a: '5 km/jam', b: '8 km/jam', c: '10 km/jam', d: '12 km/jam' },
    jawaban: 'c',
    pembahasan: 'Jarak A-B = 8×5 = 40 km. Total jarak pp = 80 km, total waktu = 5+3 = 8 jam. 80÷8 = 10 km/jam'
  },
  {
    id: 'ARI-013',
    soal: 'Suatu perlombaan lari diadakan dengan dua kali perhentian. Jarak start-A adalah 2 km, A-B adalah 7,5 km, dan B-finish adalah 1,5 km. Berapa total jarak tempuh perlombaan tersebut?',
    pilihan: { a: '10 km', b: '11 km', c: '12 km', d: '13 km' },
    jawaban: 'b',
    pembahasan: '2 + 7,5 + 1,5 = 11 km'
  },
  {
    id: 'ARI-014',
    soal: 'Wiwik berangkat dari kota P pukul 6:15 dan sampai di kota M pukul 9:45. Ia mengendarai mobil dengan kecepatan rata-rata 60 km/jam dan istirahat 1 jam. Berapa km jarak kota P dan M?',
    pilihan: { a: '120 km', b: '135 km', c: '150 km', d: '155 km' },
    jawaban: 'c',
    pembahasan: 'Total waktu = 3,5 jam, dikurangi istirahat 1 jam = 2,5 jam jalan. 60 × 2,5 = 150 km'
  },
  {
    id: 'ARI-015',
    soal: 'Benny berjalan kaki dengan kecepatan 5 km/jam, setelah 20 km dia berlari sehingga mencapai 60 km dalam waktu total 6 jam. Berapa kecepatan rata-rata Benny?',
    pilihan: { a: '10', b: '8', c: '6', d: '5' },
    jawaban: 'a',
    pembahasan: 'Kecepatan rata-rata = total jarak ÷ total waktu = 60 ÷ 6 = 10 km/jam'
  },
  {
    id: 'ARI-016',
    soal: 'Jika cuaca berkabut, sebuah mobil berjalan 30 km/jam. Jika cuaca baik, kecepatannya 60 km/jam. Berapa lama menempuh 210 km jika 2/7 dari perjalanan bercuaca buruk?',
    pilihan: { a: '3,5 jam', b: '5 jam', c: '4,5 jam', d: '4 jam' },
    jawaban: 'c',
    pembahasan: 'Jarak kabut = 2/7×210 = 60 km (waktu 2 jam). Jarak baik = 150 km (waktu 2,5 jam). Total 4,5 jam'
  },
  {
    id: 'ARI-017',
    soal: 'Dengan 4 liter bensin sebuah mobil dapat menempuh jarak 32 km. Jika jarak yang ditempuh 56 km, berapa liter bensin diperlukan?',
    pilihan: { a: '5 liter', b: '6 liter', c: '7 liter', d: '8 liter' },
    jawaban: 'c',
    pembahasan: '32 km per 4 liter = 8 km/liter. 56 ÷ 8 = 7 liter'
  },
  {
    id: 'ARI-018',
    soal: 'Perbandingan hewan bersifat PQ dengan yang tidak bersifat PQ adalah 5:3, dan 3/8 dari hewan yang bersifat PQ adalah jantan. Berapa perbandingan populasi hewan PQ jantan terhadap populasi seluruhnya?',
    pilihan: { a: '2/2', b: '6/8', c: '8/14', d: '15/64' },
    jawaban: 'd',
    pembahasan: 'PQ = 5/8 dari total. PQ jantan = 3/8 × 5/8 = 15/64 dari total'
  },
  {
    id: 'ARI-019',
    soal: 'Jika roda pertama berputar 2 kali maka roda kedua berputar 5 kali. Berapa kali roda kedua berputar jika roda pertama berputar 6 kali?',
    pilihan: { a: '11', b: '13', c: '15', d: '17' },
    jawaban: 'c',
    pembahasan: 'Rasio 2:5. Roda pertama 6 kali = 3× lipat dari 2, jadi roda kedua = 5×3 = 15'
  },
  {
    id: 'ARI-020',
    soal: 'Yandi berjalan ke Utara menempuh 2/5 km dalam 5 menit. Berapa kecepatan rata-rata perjalanan Yandi dalam 1 jam?',
    pilihan: { a: '4,5 km', b: '4,3 km', c: '5 km', d: '4,8 km' },
    jawaban: 'd',
    pembahasan: '(2/5 km ÷ 5 menit) × 60 menit = 4,8 km/jam'
  },
  {
    id: 'ARI-021',
    soal: 'Garis tengah roda A dan C = 10 cm, roda B dan D = 5 cm. Apabila roda A berputar 1 kali sempurna (A-B satu poros, B-C bergerigi, C-D satu poros), roda D akan berputar sebanyak?',
    pilihan: { a: '1 kali', b: '2 kali', c: '4 kali', d: '6 kali' },
    jawaban: 'c',
    pembahasan: 'A ke B (rasio 10:5): B berputar 2×. B-C satu poros jadi C juga 2×. C ke D (rasio 10:5): D = 2×2 = 4 kali'
  },
  {
    id: 'ARI-022',
    soal: 'Dalam suatu balap mobil, seorang pembalap menempuh jarak 10 km dalam waktu 6 menit. Berapa kecepatan rata-rata mobil itu?',
    pilihan: { a: '110 km/jam', b: '100 km/jam', c: '90 km/jam', d: '60 km/jam' },
    jawaban: 'b',
    pembahasan: '10 km ÷ 6 menit × 60 = 100 km/jam'
  },
  {
    id: 'ARI-023',
    soal: 'Sebuah kebun bunga persegipanjang panjang 16 m dan lebar 12 m. Sekeliling kebun dibangun jalan lebar 3 m. Berapa luas jalan itu?',
    pilihan: { a: '93', b: '168', c: '204', d: '186' },
    jawaban: 'c',
    pembahasan: 'Luas total dgn jalan = 22×18 = 396 m². Luas kebun = 16×12 = 192 m². Luas jalan = 396-192 = 204 m²'
  },
  {
    id: 'ARI-024',
    soal: 'Drew naik mobil berangkat pukul 07.00 dari kota A ke B dengan kecepatan 60 km/jam. Hasan naik motor berangkat pukul 07.00 dari B ke A dengan kecepatan 40 km/jam. Jarak A-B = 350 km. Mereka bertemu pukul berapa?',
    pilihan: { a: '09.50', b: '10.30', c: '10.50', d: '11.35' },
    jawaban: 'b',
    pembahasan: 'Kecepatan gabungan = 100 km/jam. Waktu ketemu = 350÷100 = 3,5 jam sejak 07.00 = 10.30'
  },
  {
    id: 'ARI-025',
    soal: 'Kalau Ani berjalan 8 meter ke muka dan mundur lagi 4 meter ke belakang, berapa jarak Ani dari tempat semula?',
    pilihan: { a: '2 meter', b: '3 meter', c: '4 meter', d: '5 meter' },
    jawaban: 'c',
    pembahasan: '8 - 4 = 4 meter'
  },
  {
    id: 'ARI-026',
    soal: 'Di permukaan laut, air mendidih pada 100°C jika tekanan udara normal. Di daerah yang lebih tinggi, tekanan udara sering kali lebih rendah dari normal. Di daerah ini air akan...',
    pilihan: { a: 'Selalu mendidih pada suhu 100°C', b: 'Selalu mendidih di atas 100°C', c: 'Sering mendidih di bawah 100°C', d: 'Tidak pernah mendidih pada 100°C' },
    jawaban: 'c',
    pembahasan: 'Karena tekanan "sering kali" (bukan selalu) lebih rendah, air "sering" (bukan selalu) mendidih di bawah 100°C'
  },
  {
    id: 'ARI-027',
    soal: 'Kereta api A berangkat dari Jogja ke Purwokerto dengan kecepatan 50 km/jam selama 4 jam. Kereta B berangkat dari Purwokerto ke Jogja menempuh jarak yang sama selama 5 jam. Berapa km/jam kecepatan kereta B?',
    pilihan: { a: '20', b: '25', c: '35', d: '40' },
    jawaban: 'd',
    pembahasan: 'Jarak = 50×4 = 200 km. Kecepatan B = 200÷5 = 40 km/jam'
  },
  {
    id: 'ARI-028',
    soal: 'Rumah Mita berjarak 1,5 km dari sekolah. Jika Mita berjalan rata-rata 4,5 km/jam, berapa jam total ditempuh Mita untuk pergi-pulang sekolah selama satu minggu (6 hari sekolah)?',
    pilihan: { a: '4 jam', b: '24 jam', c: '2 jam', d: '1/3 jam' },
    jawaban: 'a',
    pembahasan: 'Waktu 1x jalan = 1,5÷4,5 = 1/3 jam. Pergi-pulang = 2/3 jam/hari × 6 hari = 4 jam'
  },
  {
    id: 'ARI-029',
    soal: 'Waktu di kota A adalah 3 jam lebih cepat daripada kota B. Sebuah pesawat berangkat dari kota A menuju kota B pukul 5 pagi dan tiba 4 jam kemudian. Pukul berapa pesawat itu tiba di kota B?',
    pilihan: { a: '2 pagi', b: '6 pagi', c: '4 pagi', d: '3 pagi' },
    jawaban: 'b',
    pembahasan: 'Tiba (waktu A) = 5+4 = pukul 9 pagi waktu A. Karena B tertinggal 3 jam dari A: 9-3 = pukul 6 pagi waktu B'
  },
  {
    id: 'ARI-030',
    soal: 'Sebuah mobil menempuh 120 km dengan kecepatan rata-rata 60 km/jam, lalu kembali ke tempat semula dengan kecepatan 40 km/jam. Berapa kecepatan rata-rata seluruh perjalanan?',
    pilihan: { a: '60', b: '54', c: '50', d: '48' },
    jawaban: 'd',
    pembahasan: 'Total jarak 240 km, total waktu = 120/60 + 120/40 = 2+3 = 5 jam. 240÷5 = 48 km/jam'
  },
  {
    id: 'ARI-031',
    soal: 'Hilmy, Faris, Zidan membawa tongkat sepanjang 3 m, 4 m, 5 m. Jika ujung-ujung tongkat dipertemukan di atas tanah, berapa luas tanah maksimal yang terbentuk?',
    pilihan: { a: '5 meter persegi', b: '6 meter persegi', c: '7 meter persegi', d: '8 meter persegi' },
    jawaban: 'b',
    pembahasan: 'Tongkat 3-4-5 membentuk segitiga siku-siku. Luas = 1/2 × 3 × 4 = 6 m²'
  },
  {
    id: 'ARI-032',
    soal: 'Sebuah bengkel butuh waktu 5 jam untuk mengisi 3 buah aki. Berapa lama waktu dibutuhkan untuk mengisi 12 aki?',
    pilihan: { a: '15 jam', b: '18 jam', c: '20 jam', d: '21 jam' },
    jawaban: 'c',
    pembahasan: 'Rate = 5/3 jam per aki. 12 aki × 5/3 = 20 jam'
  },
  {
    id: 'ARI-033',
    soal: 'Sebuah wadah silinder diisi air 1/3-nya, lalu ditambah 3 liter air sehingga menjadi 1/2-nya. Berapa kapasitas wadah tersebut?',
    pilihan: { a: '25', b: '18', c: '20', d: '22' },
    jawaban: 'b',
    pembahasan: 'Selisih 1/2-1/3 = 1/6 kapasitas = 3 liter, jadi kapasitas total = 18 liter'
  },
  {
    id: 'ARI-034',
    soal: 'Seekor burung merpati terbang 5 km ke arah Barat lalu ke arah Utara. Ke arah mana burung tersebut harus terbang supaya sampai di tempat semula?',
    pilihan: { a: 'Tenggara', b: 'Selatan', c: 'Barat Daya', d: 'Barat Laut' },
    jawaban: 'a',
    pembahasan: 'Terbang Barat lalu Utara membuat posisi di arah Barat Laut dari start, jadi untuk kembali arahnya Tenggara'
  },
  {
    id: 'ARI-035',
    soal: 'Asep memiliki 6 warung, tiap warung butuh 5 liter minyak. Satu botol berisi 4 liter dijual Rp 12.000, satu liter satuan dijual Rp 5.000. Berapa jumlah minimum yang harus dikeluarkan Asep?',
    pilihan: { a: 'Rp 84.000', b: 'Rp 94.000', c: 'Rp 96.000', d: 'Rp 102.000' },
    jawaban: 'b',
    pembahasan: 'Butuh 30 liter. 7 botol (28L) = Rp84.000 + 2 liter satuan (Rp10.000) = Rp94.000 (lebih murah dari 8 botol = Rp96.000)'
  },
  {
    id: 'ARI-036',
    soal: 'Sebuah kolam renang berisi 300 meter kubik air. Luas kolam itu 100 meter persegi. Berapa dalamnya kolam itu?',
    pilihan: { a: '3 meter', b: '4 meter', c: '5 meter', d: '6 meter' },
    jawaban: 'a',
    pembahasan: 'Dalam = volume ÷ luas = 300 ÷ 100 = 3 meter'
  },
  {
    id: 'ARI-037',
    soal: 'Seorang karyawan mengendarai motor sejauh 40 km ke tempat kerja tiap pagi dalam 55 menit. Suatu pagi ia terlambat 7 menit dari biasanya, berapa kecepatan yang harus ditempuh supaya sampai tepat waktu seperti biasa?',
    pilihan: { a: '42 km/jam', b: '45 km/jam', c: '54 km/jam', d: '50 km/jam' },
    jawaban: 'd',
    pembahasan: 'Waktu tersisa = 55-7 = 48 menit = 0,8 jam. Kecepatan = 40÷0,8 = 50 km/jam'
  },
  {
    id: 'ARI-038',
    soal: 'Seekor burung terbang dengan kecepatan rata-rata 25 km/jam. Berapa panjang lintasan yang ditempuh burung selama 3 jam?',
    pilihan: { a: '75 km', b: '80 km', c: '82 km', d: '85 km' },
    jawaban: 'a',
    pembahasan: '25 × 3 = 75 km'
  },
  {
    id: 'ARI-039',
    soal: 'Seekor kancil dapat berlari dengan kecepatan 80 km/jam. Berapa menit yang diperlukan kancil untuk menempuh jarak 8 km?',
    pilihan: { a: '9 menit', b: '8 menit', c: '7 menit', d: '6 menit' },
    jawaban: 'd',
    pembahasan: '8÷80 jam = 0,1 jam = 6 menit'
  },
  {
    id: 'ARI-040',
    soal: 'Rina menempuh 4/5 lingkaran dalam waktu x menit. Berapa lama waktu yang diperlukan Rina untuk menempuh satu lingkaran penuh?',
    pilihan: { a: 'x/4', b: '5x/4', c: '4x/5', d: '5/4x' },
    jawaban: 'b',
    pembahasan: 'Waktu 1 lingkaran = x ÷ (4/5) = 5x/4'
  },
  {
    id: 'ARI-041',
    soal: 'Naufal membeli tripleks persegi dengan luas 169 meter persegi. Ia memotong 2 m pada salah satu sisinya agar pas menutup sisi tembok. Berapa luas dinding itu?',
    pilihan: { a: '113 meter persegi', b: '121 meter persegi', c: '143 meter persegi', d: '145 meter persegi' },
    jawaban: 'c',
    pembahasan: 'Sisi tripleks = √169 = 13 m. Setelah dipotong 2m jadi 11m. Luas = 13×11 = 143 m²'
  },
  {
    id: 'ARI-042',
    soal: 'Seorang pedagang air memindahkan 900 liter air dari bak ke drum pakai ember, tersisa 870 liter. Tiap kali pakai ember, air berkurang 3 liter. Berapa ember yang digunakan?',
    pilihan: { a: '8 ember', b: '9 ember', c: '10 ember', d: '11 ember' },
    jawaban: 'c',
    pembahasan: 'Total berkurang = 900-870 = 30 liter. 30÷3 = 10 ember'
  },
  {
    id: 'ARI-043',
    soal: 'Sepotong kayu panjang 40 meter dipotong 2 bagian, salah satu bagian panjangnya 2/3 dari bagian lainnya. Berapa panjang bagian terpendek?',
    pilihan: { a: '16 m', b: '18 m', c: '22 m', d: '24 m' },
    jawaban: 'a',
    pembahasan: 'Bagian panjang (x) + 2/3x = 40 → x=24. Bagian pendek = 2/3×24 = 16 m'
  },
  {
    id: 'ARI-044',
    soal: 'Sebuah mobil menempuh 15 km dengan 1 liter bensin saat dipacu 50 km/jam. Jika dipacu 60 km/jam, jaraknya hanya 80% dari itu. Berapa bensin diperlukan untuk menempuh 120 km dengan kecepatan 60 km/jam?',
    pilihan: { a: '8 liter', b: '64 liter', c: '9,6 liter', d: '10 liter' },
    jawaban: 'd',
    pembahasan: 'Efisiensi di 60 km/jam = 15×80% = 12 km/liter. 120÷12 = 10 liter'
  },
  {
    id: 'ARI-045',
    soal: 'Seorang pengamen dapat mengumpulkan uang rata-rata Rp 6.000 tiap jam. Berapa waktu yang diperlukan untuk mendapatkan Rp 50.000?',
    pilihan: { a: '7 jam', b: '7 jam 4 menit', c: '8 jam', d: '8 jam 20 menit' },
    jawaban: 'd',
    pembahasan: '50.000÷6.000 = 8,33 jam = 8 jam 20 menit'
  },
  {
    id: 'ARI-046',
    soal: 'Seseorang berjalan dari titik x ke Timur 1 km, lalu 2 km Utara, 1 km Timur, 1 km Utara, 1 km Timur, dan terakhir 1 km Utara hingga sampai di titik y. Berapa km jarak lurus antara titik x dan y?',
    pilihan: { a: '10', b: '5', c: '7', d: '6' },
    jawaban: 'b',
    pembahasan: 'Total Timur = 3 km, total Utara = 4 km. Jarak lurus = √(3²+4²) = √25 = 5 km'
  },
  {
    id: 'ARI-047',
    soal: 'Jika x = berat total p kotak yang masing-masing beratnya q kg, dan y = berat total q kotak yang masing-masing beratnya p kg, maka hubungan x dan y adalah?',
    pilihan: { a: 'x>y', b: 'x<y', c: 'x=y', d: 'x dan y tak dapat ditentukan' },
    jawaban: 'c',
    pembahasan: 'x = p×q dan y = q×p, secara matematis selalu sama: x=y'
  },
  {
    id: 'ARI-048',
    soal: 'Sebuah bangunan berbentuk balok volume 162 meter kubik. Sisi panjangnya 6 m, sisi pendeknya 3 m. Berapa cm tingginya?',
    pilihan: { a: '600 cm', b: '700 cm', c: '800 cm', d: '900 cm' },
    jawaban: 'd',
    pembahasan: 'Tinggi = 162÷(6×3) = 9 meter = 900 cm'
  },
  {
    id: 'ARI-049',
    soal: 'Seorang pengangkut batu mengangkut 500 kg dalam 5 hari. Hari 1-4 mengangkut 90, 75, 120, dan 30 kg. Berapa gram yang diangkut pada hari ke-5?',
    pilihan: { a: '185.000 gram', b: '180.000 gram', c: '175.000 gram', d: '165.000 gram' },
    jawaban: 'a',
    pembahasan: 'Total hari 1-4 = 90+75+120+30 = 315 kg. Hari ke-5 = 500-315 = 185 kg = 185.000 gram'
  },
];

// ------------------------------------------------------------
// 3. HITUNG CEPAT (dari "TES KEMAMPUAN KECERDASAN.doc")
//    Format: ekspresi aritmatika langsung, user isi hasilnya.
//    Semua jawaban dihitung ulang & diverifikasi (kaidah operasi
//    hitung standar: kali/bagi dulu baru tambah/kurang, kiri ke
//    kanan untuk operator setingkat).
// ------------------------------------------------------------
export const soalHitungCepat = [
  { id: 'HTG-001', ekspresi: '9 + 12 + 16', jawaban: 37 },
  { id: 'HTG-002', ekspresi: '36 + 72 − 28', jawaban: 80 },
  { id: 'HTG-003', ekspresi: '40 + 19 − 15 − 5', jawaban: 39 },
  { id: 'HTG-004', ekspresi: '28 + 11 + 46 + 12', jawaban: 97 },
  { id: 'HTG-005', ekspresi: '9 × 8 + 25 + 6', jawaban: 103 },
  { id: 'HTG-006', ekspresi: '5 × 10 + 25 + 6', jawaban: 81 },
  { id: 'HTG-007', ekspresi: '10 × 12 − 40 − 15', jawaban: 65 },
  { id: 'HTG-008', ekspresi: '5 × 7 × 14', jawaban: 490 },
  { id: 'HTG-009', ekspresi: '15 × 10 ÷ 5 − 14', jawaban: 16 },
  { id: 'HTG-010', ekspresi: '7 × 8 ÷ 4 − 16', jawaban: -2 },
  { id: 'HTG-011', ekspresi: '10 × 10 ÷ 100 − 9', jawaban: -8 },
  { id: 'HTG-012', ekspresi: '160 ÷ 16 + 20 − 30', jawaban: 0 },
  { id: 'HTG-013', ekspresi: '125 ÷ 25 + 25 − 49', jawaban: -19 },
  { id: 'HTG-014', ekspresi: '75 ÷ 15 + 25 − 31', jawaban: -1 },
  { id: 'HTG-015', ekspresi: '6 × 6 ÷ 6 + 54', jawaban: 60 },
  { id: 'HTG-016', ekspresi: '100 × 10 ÷ 100 − 9', jawaban: 1 },
  { id: 'HTG-017', ekspresi: '4 × 4 × 4 × 4', jawaban: 256 },
  { id: 'HTG-018', ekspresi: '2 × 25 ÷ 50 + 10', jawaban: 11 },
  { id: 'HTG-019', ekspresi: '1000 ÷ 500 + 98 − 90', jawaban: 10 },
  { id: 'HTG-020', ekspresi: '2 × 5 × 2 × 5', jawaban: 100 },
  { id: 'HTG-021', ekspresi: '( 5 + 35 + 45 + 15 ) ÷ 10', jawaban: 10 },
  { id: 'HTG-022', ekspresi: '( 25 + 30 + 15 + 5 ) ÷ 15', jawaban: 5 },
  { id: 'HTG-023', ekspresi: '( 3 × 20 + 20 − 10 ) ÷ 10', jawaban: 7 },
  { id: 'HTG-024', ekspresi: '( 4 × 8 + 8 + 5 ) ÷ 15', jawaban: 3 },
  { id: 'HTG-025', ekspresi: '( 7 + 17 + 6 − 5 ) ÷ 25', jawaban: 1 },
  { id: 'HTG-026', ekspresi: '6 × 5 × 3 − 20 − 15', jawaban: 55 },
  { id: 'HTG-027', ekspresi: '4 × 25 ÷ 5 + 30 − 10', jawaban: 40 },
  { id: 'HTG-028', ekspresi: '8 × 9 ÷ 9 + 8 + 4 − 2', jawaban: 18 },
  { id: 'HTG-029', ekspresi: '6 × 7 ÷ 6 + 17 + 20', jawaban: 44 },
  { id: 'HTG-030', ekspresi: '9 × 0 + 25 + 75 − 40', jawaban: 60 },
];

// ------------------------------------------------------------
// HELPER FUNCTIONS
// ------------------------------------------------------------

/**
 * Ambil n soal acak dari array
 */
function getRandomSoal(arr, n) {
  const shuffled = [...arr].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, n);
}

/**
 * Soal deret angka — default 15 soal acak
 */
export function getRandomSoalDeret(n = 15) {
  return getRandomSoal(soalDeretAngka, n);
}

/**
 * Soal hitung cepat — default 15 soal acak
 */
export function getRandomSoalHitungCepat(n = 15) {
  return getRandomSoal(soalHitungCepat, n);
}

/**
 * Soal aritmatika cerita — default 15 soal acak
 */
export function getRandomSoalAritmatika(n = 15) {
  return getRandomSoal(soalAritmatika, n);
}

/**
 * Mix semua jenis soal — default 30 soal
 * 15 deret + 15 aritmatika
 */
export function getRandomSoalLogika(totalSoal = 30) {
  const half = Math.floor(totalSoal / 2);
  const deret = getRandomSoalDeret(half);
  const aritmatika = getRandomSoalAritmatika(totalSoal - half);

  // Tag jenis soal
  const tagged = [
    ...deret.map(s => ({ ...s, jenis: 'deret' })),
    ...aritmatika.map(s => ({ ...s, jenis: 'aritmatika' })),
  ];

  // Acak urutan campuran
  return tagged.sort(() => Math.random() - 0.5);
}

/**
 * Hitung skor akhir
 * @param {Array} jawabanUser - [{ id, jawaban }]
 * @param {Array} soalList    - array soal yang digunakan
 * @returns {Object} { benar, salah, kosong, skor, total }
 */
export function hitungSkorLogika(jawabanUser, soalList) {
  let benar = 0, salah = 0, kosong = 0;

  soalList.forEach(soal => {
    const userJawab = jawabanUser.find(j => j.id === soal.id);
    if (!userJawab || userJawab.jawaban === null || userJawab.jawaban === undefined || userJawab.jawaban === '') {
      kosong++;
    } else {
      // Deret: bandingkan angka; Aritmatika: bandingkan huruf
      const benarJawab = soal.jenis === 'deret'
        ? Number(userJawab.jawaban) === Number(soal.jawaban)
        : userJawab.jawaban === soal.jawaban;

      if (benarJawab) benar++;
      else salah++;
    }
  });

  const total = soalList.length;
  const skor = Math.round((benar / total) * 100);

  return { benar, salah, kosong, skor, total };
}

// ===== SOAL TAMBAHAN BARU =====

// DERET ANGKA — tambahan soal baru (soal lama tetap dipertahankan)
soalDeretAngka.push(
  { id: 'DRT-135', deret: "3, 9, 15, 21, 27, ...", jawaban: 33, pola: "+6" },
  { id: 'DRT-136', deret: "8, 17, 26, 35, 44, ...", jawaban: 53, pola: "+9" },
  { id: 'DRT-137', deret: "12, 16, 20, 24, 28, ...", jawaban: 32, pola: "+4" },
  { id: 'DRT-138', deret: "20, 27, 34, 41, 48, ...", jawaban: 55, pola: "+7" },
  { id: 'DRT-139', deret: "5, 13, 21, 29, 37, ...", jawaban: 45, pola: "+8" },
  { id: 'DRT-140', deret: "14, 25, 36, 47, 58, ...", jawaban: 69, pola: "+11" },
  { id: 'DRT-141', deret: "9, 14, 19, 24, 29, ...", jawaban: 34, pola: "+5" },
  { id: 'DRT-142', deret: "2, 15, 28, 41, 54, ...", jawaban: 67, pola: "+13" },
  { id: 'DRT-143', deret: "90, 83, 76, 69, 62, ...", jawaban: 55, pola: "-7" },
  { id: 'DRT-144', deret: "120, 112, 104, 96, 88, ...", jawaban: 80, pola: "-8" },
  { id: 'DRT-145', deret: "77, 71, 65, 59, 53, ...", jawaban: 47, pola: "-6" },
  { id: 'DRT-146', deret: "150, 138, 126, 114, 102, ...", jawaban: 90, pola: "-12" },
  { id: 'DRT-147', deret: "64, 59, 54, 49, 44, ...", jawaban: 39, pola: "-5" },
  { id: 'DRT-148', deret: "2, 4, 8, 16, 32, ...", jawaban: 64, pola: "×2" },
  { id: 'DRT-149', deret: "3, 6, 12, 24, 48, ...", jawaban: 96, pola: "×2" },
  { id: 'DRT-150', deret: "1, 3, 9, 27, 81, ...", jawaban: 243, pola: "×3" },
  { id: 'DRT-151', deret: "2, 6, 18, 54, 162, ...", jawaban: 486, pola: "×3" },
  { id: 'DRT-152', deret: "5, 10, 20, 40, 80, ...", jawaban: 160, pola: "×2" },
  { id: 'DRT-153', deret: "4, 8, 16, 32, 64, ...", jawaban: 128, pola: "×2" },
  { id: 'DRT-154', deret: "1, 4, 16, 64, 256, ...", jawaban: 1024, pola: "×4" },
  { id: 'DRT-155', deret: "3, 9, 27, 81, 243, ...", jawaban: 729, pola: "×3" },
  { id: 'DRT-156', deret: "1, 2, 4, 7, 11, ...", jawaban: 16, pola: "selisih naik +1" },
  { id: 'DRT-157', deret: "2, 4, 8, 14, 22, ...", jawaban: 32, pola: "selisih naik +2" },
  { id: 'DRT-158', deret: "3, 6, 12, 21, 33, ...", jawaban: 48, pola: "selisih naik +3" },
  { id: 'DRT-159', deret: "5, 6, 8, 11, 15, ...", jawaban: 20, pola: "selisih naik +1" },
  { id: 'DRT-160', deret: "4, 9, 16, 25, 36, ...", jawaban: 49, pola: "bilangan kuadrat berurutan" },
  { id: 'DRT-161', deret: "9, 16, 25, 36, 49, ...", jawaban: 64, pola: "bilangan kuadrat berurutan" },
  { id: 'DRT-162', deret: "16, 25, 36, 49, 64, ...", jawaban: 81, pola: "bilangan kuadrat berurutan" },
  { id: 'DRT-163', deret: "25, 36, 49, 64, 81, ...", jawaban: 100, pola: "bilangan kuadrat berurutan" },
  { id: 'DRT-164', deret: "36, 49, 64, 81, 100, ...", jawaban: 121, pola: "bilangan kuadrat berurutan" },
  { id: 'DRT-165', deret: "49, 64, 81, 100, 121, ...", jawaban: 144, pola: "bilangan kuadrat berurutan" },
  { id: 'DRT-166', deret: "1, 1, 2, 3, 5, ...", jawaban: 8, pola: "tiap suku = jumlah dua suku sebelumnya" },
  { id: 'DRT-167', deret: "2, 3, 5, 8, 13, ...", jawaban: 21, pola: "tiap suku = jumlah dua suku sebelumnya" },
  { id: 'DRT-168', deret: "1, 3, 4, 7, 11, ...", jawaban: 18, pola: "tiap suku = jumlah dua suku sebelumnya" },
  { id: 'DRT-169', deret: "2, 2, 4, 6, 10, ...", jawaban: 16, pola: "tiap suku = jumlah dua suku sebelumnya" },
  { id: 'DRT-170', deret: "2, 5, 3, 6, 4, ...", jawaban: 7, pola: "bergantian +3 dan -2" },
  { id: 'DRT-171', deret: "5, 9, 8, 12, 11, ...", jawaban: 15, pola: "bergantian +4 dan -1" },
  { id: 'DRT-172', deret: "10, 15, 12, 17, 14, ...", jawaban: 19, pola: "bergantian +5 dan -3" },
  { id: 'DRT-173', deret: "6, 8, 7, 9, 8, ...", jawaban: 10, pola: "bergantian +2 dan -1" },
  { id: 'DRT-174', deret: "2, 4, 7, 14, 17, ...", jawaban: 34, pola: "bergantian ×2 dan +3" },
  { id: 'DRT-175', deret: "1, 3, 5, 15, 17, ...", jawaban: 51, pola: "bergantian ×3 dan +2" },
  { id: 'DRT-176', deret: "4, 8, 12, 24, 28, ...", jawaban: 56, pola: "bergantian ×2 dan +4" },
);

// HITUNG CEPAT — tambahan soal baru (soal lama tetap dipertahankan)
soalHitungCepat.push(
  { id: 'HTG-091', ekspresi: "20 + 42 + 21", jawaban: 83 },
  { id: 'HTG-092', ekspresi: "81 + 16 − 9", jawaban: 88 },
  { id: 'HTG-093', ekspresi: "27 + 16 − 19 + 7", jawaban: 31 },
  { id: 'HTG-094', ekspresi: "29 + 32 + 28", jawaban: 89 },
  { id: 'HTG-095', ekspresi: "112 + 16 − 11", jawaban: 117 },
  { id: 'HTG-096', ekspresi: "23 + 39 − 19 + 20", jawaban: 63 },
  { id: 'HTG-097', ekspresi: "54 + 16 + 39", jawaban: 109 },
  { id: 'HTG-098', ekspresi: "70 + 33 − 15", jawaban: 88 },
  { id: 'HTG-099', ekspresi: "41 + 34 − 18 + 15", jawaban: 72 },
  { id: 'HTG-100', ekspresi: "21 + 52 + 27", jawaban: 100 },
  { id: 'HTG-101', ekspresi: "94 + 14 − 28", jawaban: 80 },
  { id: 'HTG-102', ekspresi: "43 + 28 − 14 + 11", jawaban: 68 },
  { id: 'HTG-103', ekspresi: "23 + 11 + 37", jawaban: 71 },
  { id: 'HTG-104', ekspresi: "104 + 41 − 19", jawaban: 126 },
  { id: 'HTG-105', ekspresi: "37 + 21 − 14 + 9", jawaban: 53 },
  { id: 'HTG-106', ekspresi: "60 + 58 + 27", jawaban: 145 },
  { id: 'HTG-107', ekspresi: "52 + 27 − 21", jawaban: 58 },
  { id: 'HTG-108', ekspresi: "52 + 31 − 7 + 17", jawaban: 93 },
  { id: 'HTG-109', ekspresi: "41 + 20 + 25", jawaban: 86 },
  { id: 'HTG-110', ekspresi: "85 + 13 − 12", jawaban: 86 },
  { id: 'HTG-111', ekspresi: "41 + 40 − 16 + 9", jawaban: 74 },
  { id: 'HTG-112', ekspresi: "56 + 51 + 20", jawaban: 127 },
  { id: 'HTG-113', ekspresi: "71 + 22 − 24", jawaban: 69 },
  { id: 'HTG-114', ekspresi: "31 + 21 − 8 + 17", jawaban: 61 },
  { id: 'HTG-115', ekspresi: "21 + 29 + 13", jawaban: 63 },
  { id: 'HTG-116', ekspresi: "71 + 35 − 21", jawaban: 85 },
  { id: 'HTG-117', ekspresi: "24 + 18 − 11 + 5", jawaban: 36 },
  { id: 'HTG-118', ekspresi: "43 + 57 + 19", jawaban: 119 },
  { id: 'HTG-119', ekspresi: "106 + 46 − 10", jawaban: 142 },
  { id: 'HTG-120', ekspresi: "46 + 22 − 23 + 11", jawaban: 56 },
);

// ARITMATIKA CERITA — tambahan soal baru (soal lama tetap dipertahankan)
soalAritmatika.push(
  { id: "ARI-090", soal: "Seorang prajurit berlari 11 km, 9 km, dan 7 km dalam tiga hari. Berapa rata-rata km per hari?", pilihan: { a: "11 km", b: "12 km", c: "8 km", d: "9 km", e: "14 km" }, jawaban: 'd', pembahasan: "(11+9+7) ÷ 3 = 9" },
  { id: "ARI-091", soal: "Sebuah kompi terdiri dari 120 prajurit. Jika 50% mengikuti latihan menembak, berapa prajurit yang ikut?", pilihan: { a: "42", b: "60", c: "90", d: "72", e: "54" }, jawaban: 'b', pembahasan: "50% × 120 = 60" },
  { id: "ARI-092", soal: "Sebuah truk bergerak dengan kecepatan tetap 80 km/jam selama 4 jam. Jarak yang ditempuh?", pilihan: { a: "320 km", b: "640 km", c: "160 km", d: "480 km", e: "352 km" }, jawaban: 'a', pembahasan: "80 × 4 = 320 km" },
  { id: "ARI-093", soal: "Sebuah gudang menyimpan 5 rak. Tiap rak berisi 10 kotak, dan tiap kotak berisi 3 peralatan. Berapa seluruh peralatan?", pilihan: { a: "195", b: "225", c: "75", d: "135", e: "150" }, jawaban: 'e', pembahasan: "5 × 10 × 3 = 150" },
  { id: "ARI-094", soal: "Harga satu buah topi lapangan Rp15.000. Berapa total (dalam ribu rupiah) untuk membeli 6 buah?", pilihan: { a: "63 ribu", b: "117 ribu", c: "90 ribu", d: "108 ribu", e: "72 ribu" }, jawaban: 'c', pembahasan: "15 × 6 = 90 ribu" },
  { id: "ARI-095", soal: "Seorang prajurit berlari 5 km, 10 km, dan 6 km dalam tiga hari. Berapa rata-rata km per hari?", pilihan: { a: "6 km", b: "12 km", c: "17 km", d: "7 km", e: "5 km" }, jawaban: 'd', pembahasan: "(5+10+6) ÷ 3 = 7" },
  { id: "ARI-096", soal: "Sebuah gudang menyimpan 5 rak. Tiap rak berisi 6 kotak, dan tiap kotak berisi 5 peralatan. Berapa seluruh peralatan?", pilihan: { a: "150", b: "105", c: "165", d: "120", e: "195" }, jawaban: 'a', pembahasan: "5 × 6 × 5 = 150" },
  { id: "ARI-097", soal: "Harga satu buah topi lapangan Rp15.000. Berapa total (dalam ribu rupiah) untuk membeli 4 buah?", pilihan: { a: "60 ribu", b: "30 ribu", c: "48 ribu", d: "120 ribu", e: "54 ribu" }, jawaban: 'a', pembahasan: "15 × 4 = 60 ribu" },
  { id: "ARI-098", soal: "Sebuah kompi terdiri dari 120 prajurit. Jika 25% mengikuti latihan menembak, berapa prajurit yang ikut?", pilihan: { a: "30", b: "45", c: "39", d: "15", e: "27" }, jawaban: 'a', pembahasan: "25% × 120 = 30" },
  { id: "ARI-099", soal: "Sebuah truk bergerak dengan kecepatan tetap 80 km/jam selama 3 jam. Jarak yang ditempuh?", pilihan: { a: "480 km", b: "192 km", c: "240 km", d: "288 km", e: "120 km" }, jawaban: 'c', pembahasan: "80 × 3 = 240 km" },
  { id: "ARI-100", soal: "Sebuah gudang menyimpan 6 rak. Tiap rak berisi 10 kotak, dan tiap kotak berisi 5 peralatan. Berapa seluruh peralatan?", pilihan: { a: "150", b: "600", c: "240", d: "450", e: "300" }, jawaban: 'e', pembahasan: "6 × 10 × 5 = 300" },
  { id: "ARI-101", soal: "Harga satu buah topi lapangan Rp15.000. Berapa total (dalam ribu rupiah) untuk membeli 8 buah?", pilihan: { a: "120 ribu", b: "96 ribu", c: "240 ribu", d: "108 ribu", e: "144 ribu" }, jawaban: 'a', pembahasan: "15 × 8 = 120 ribu" },
  { id: "ARI-102", soal: "Seorang prajurit berlari 6 km, 12 km, dan 12 km dalam tiga hari. Berapa rata-rata km per hari?", pilihan: { a: "13 km", b: "5 km", c: "10 km", d: "15 km", e: "11 km" }, jawaban: 'c', pembahasan: "(6+12+12) ÷ 3 = 10" },
  { id: "ARI-103", soal: "Sebuah kompi terdiri dari 80 prajurit. Jika 25% mengikuti latihan menembak, berapa prajurit yang ikut?", pilihan: { a: "26", b: "20", c: "16", d: "10", e: "24" }, jawaban: 'b', pembahasan: "25% × 80 = 20" },
  { id: "ARI-104", soal: "Sebuah truk bergerak dengan kecepatan tetap 60 km/jam selama 4 jam. Jarak yang ditempuh?", pilihan: { a: "312 km", b: "288 km", c: "360 km", d: "240 km", e: "192 km" }, jawaban: 'd', pembahasan: "60 × 4 = 240 km" },
  { id: "ARI-105", soal: "Sebuah gudang menyimpan 6 rak. Tiap rak berisi 8 kotak, dan tiap kotak berisi 2 peralatan. Berapa seluruh peralatan?", pilihan: { a: "186", b: "51", c: "87", d: "78", e: "96" }, jawaban: 'e', pembahasan: "6 × 8 × 2 = 96" },
  { id: "ARI-106", soal: "Harga satu buah topi lapangan Rp25.000. Berapa total (dalam ribu rupiah) untuk membeli 6 buah?", pilihan: { a: "120 ribu", b: "150 ribu", c: "165 ribu", d: "180 ribu", e: "135 ribu" }, jawaban: 'b', pembahasan: "25 × 6 = 150 ribu" },
  { id: "ARI-107", soal: "Seorang prajurit berlari 9 km, 12 km, dan 12 km dalam tiga hari. Berapa rata-rata km per hari?", pilihan: { a: "10 km", b: "11 km", c: "21 km", d: "8 km", e: "6 km" }, jawaban: 'b', pembahasan: "(9+12+12) ÷ 3 = 11" },
  { id: "ARI-108", soal: "Sebuah kompi terdiri dari 80 prajurit. Jika 50% mengikuti latihan menembak, berapa prajurit yang ikut?", pilihan: { a: "32", b: "40", c: "20", d: "36", e: "52" }, jawaban: 'b', pembahasan: "50% × 80 = 40" },
  { id: "ARI-109", soal: "Sebuah truk bergerak dengan kecepatan tetap 40 km/jam selama 3 jam. Jarak yang ditempuh?", pilihan: { a: "156 km", b: "144 km", c: "96 km", d: "132 km", e: "120 km" }, jawaban: 'e', pembahasan: "40 × 3 = 120 km" },
);
